// removed by extract-text-webpack-plugin
module.exports = {"day":"_19fPtsKGWdSfcpJ-2TMsm7","day-number":"_3eowMC6Jy1GT20aZk3k-s8","has-events":"_3ZOKghEdn7MWrKPcXA0SUy","different-month":"_2_TTsNYNwY0gA3zFum5IYx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/components/Day.mod.css
// module id = 1024
// module chunks = 0